"use client";
import Image from "next/image";
import { useState } from "react";

export const SeeMoreText = ({ text, maxLength = 100 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return null;

  const isLongText = text.length > maxLength;
  const displayedText =
    isExpanded || !isLongText ? text : text.substring(0, maxLength) + "...";

  return (
    <div>
      <p className="text-sm md:text-base text-gray-600 leading-relaxed">
        {displayedText}

        {isLongText && (
          <button
            onClick={() => setIsExpanded((prev) => !prev)}
            className="text-gray-500 text-sm mt-2"
          >
            {isExpanded ? "See Less" : "See More"}
          </button>
        )}
      </p>
    </div>
  );
};

export const DetailIcons = () => {
  const icons = {
    "/delivery/d1.png": "Free Delivery above ₹999/-",
    "/delivery/d2.png": "Secure Checkout",
    "/delivery/d3.png": "Partial COD Available",
    "/delivery/d4.png": "Pan India Delivery",
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-4 place-items-center">
      {Object.entries(icons).map(([iconPath, label], index) => (
        <div key={index} className="flex flex-col items-center text-center">
          <div className="relative h-9 w-9 mb-2">
            <Image
              src={iconPath}
              alt={`delivery-icon-${index + 1}`}
              fill
              style={{ objectFit: "contain" }}
              loading="lazy"
            />
          </div>
          <p className="text-xs text-gray-700 w-28">{label}</p>
        </div>
      ))}
    </div>
  );
};
